/** Shared section anchor ids for deep links and chatbot scroll-to. */
export const PAGE_SECTION_IDS = {
  hero: "hero",
  details: "details",
  enquire: "enquire",
  overview: "overview",
  providers: "providers",
  nearby: "nearby",
  moreOptions: "more-options",
  officeSearchBanner: "office-search-banner",
  faqs: "faqs",
  blogs: "blogs",
  map: "map",
  listings: "listings-container",
  workspaceListings: "properties-container",
  contact: "contact",
  contactForm: "contact-form",
  about: "about",
  compare: "compare",
  searchResults: "search-results",
  insights: "insights",
  ebooks: "ebooks",
  partners: "partners",
  googleReviews: "google-reviews",
  workspaceFinder: "workspace-finder",
  topLocations: "top-locations",
  officeOptions: "office-options",
  whyOfficeHub: "why-office-hub",
  popularLocations: "popular-locations",
  listOnOfficeHub: "list-on-office-hub",
  guidesAndTips: "guides-and-tips",
} as const;

export type PageSectionId = (typeof PAGE_SECTION_IDS)[keyof typeof PAGE_SECTION_IDS];

export const PAGE_SECTION_SCROLL_CLASS = "scroll-mt-28";

/** Map API / hash aliases → element ids. Unknown values pass through. */
const SECTION_ALIASES: Record<string, string> = {
  hero: PAGE_SECTION_IDS.hero,
  "workspace-finder": PAGE_SECTION_IDS.workspaceFinder,
  workspacefinder: PAGE_SECTION_IDS.workspaceFinder,
  "top-locations": PAGE_SECTION_IDS.topLocations,
  toplocations: PAGE_SECTION_IDS.topLocations,
  "office-options": PAGE_SECTION_IDS.officeOptions,
  officeoptions: PAGE_SECTION_IDS.officeOptions,
  "why-office-hub": PAGE_SECTION_IDS.whyOfficeHub,
  whyofficehub: PAGE_SECTION_IDS.whyOfficeHub,
  "popular-locations": PAGE_SECTION_IDS.popularLocations,
  popularlocations: PAGE_SECTION_IDS.popularLocations,
  partners: PAGE_SECTION_IDS.partners,
  partner: PAGE_SECTION_IDS.partners,
  "list-on-office-hub": PAGE_SECTION_IDS.listOnOfficeHub,
  listonofficehub: PAGE_SECTION_IDS.listOnOfficeHub,
  about: PAGE_SECTION_IDS.about,
  "google-reviews": PAGE_SECTION_IDS.googleReviews,
  googlereviews: PAGE_SECTION_IDS.googleReviews,
  reviews: PAGE_SECTION_IDS.googleReviews,
  "guides-and-tips": PAGE_SECTION_IDS.guidesAndTips,
  guidesandtips: PAGE_SECTION_IDS.guidesAndTips,
  guides: PAGE_SECTION_IDS.guidesAndTips,
  blogs: PAGE_SECTION_IDS.blogs,
  blog: PAGE_SECTION_IDS.blogs,
  "office-search-banner": PAGE_SECTION_IDS.officeSearchBanner,
  officesearchbanner: PAGE_SECTION_IDS.officeSearchBanner,
  details: PAGE_SECTION_IDS.details,
  overview: PAGE_SECTION_IDS.overview,
  enquire: PAGE_SECTION_IDS.enquire,
  "enquire-now": PAGE_SECTION_IDS.enquire,
  contact: PAGE_SECTION_IDS.contact,
  "contact-form": PAGE_SECTION_IDS.contactForm,
  contactform: PAGE_SECTION_IDS.contactForm,
  faqs: PAGE_SECTION_IDS.faqs,
  faq: PAGE_SECTION_IDS.faqs,
  nearby: PAGE_SECTION_IDS.nearby,
  "nearby-offices": PAGE_SECTION_IDS.nearby,
  nearbyoffices: PAGE_SECTION_IDS.nearby,
  map: PAGE_SECTION_IDS.map,
  listings: PAGE_SECTION_IDS.listings,
  properties: PAGE_SECTION_IDS.workspaceListings,
  "workspace-listings": PAGE_SECTION_IDS.workspaceListings,
  "more-options": PAGE_SECTION_IDS.moreOptions,
  moreoptions: PAGE_SECTION_IDS.moreOptions,
  providers: PAGE_SECTION_IDS.providers,
  "search-results": PAGE_SECTION_IDS.searchResults,
  searchresults: PAGE_SECTION_IDS.searchResults,
  insights: PAGE_SECTION_IDS.insights,
  compare: PAGE_SECTION_IDS.compare,
  ebooks: PAGE_SECTION_IDS.ebooks,
};

export function resolvePageSectionId(section?: string | null): string | null {
  if (!section || typeof section !== "string") return null;
  const normalized = section.trim().toLowerCase().replace(/^#/, "");
  if (!normalized) return null;
  return (
    SECTION_ALIASES[normalized] ||
    SECTION_ALIASES[normalized.replace(/_/g, "-")] ||
    normalized
  );
}
